import moment    from 'moment'
import Immutable from 'immutable'

import { dateFormat } from 'alto-utils/lib/utils'

import CanteenMenu         from './canteen_menu'
import DailyMenuWithOrders from './daily_menu_with_orders'

export default class CanteenMenuWithOrders extends CanteenMenu
  dailyMenuFor: (date) ->
    groupMenus = @_dailyMenus?.get(date.format(dateFormat)) or null

    new DailyMenuWithOrders(@canteen, date, groupMenus, @_menu)

  hasMeals: ->
    @_dailyMenus?

  isSaved: ->
    @dailyMenus().every (dailyMenu) -> dailyMenu.isSaved()

  hasSelection: ->
    @dailyMenus().some (dailyMenu) -> dailyMenu.hasSelection()

  allAdditionalMealsSelected: ->
    @dailyMenus().every (dailyMenu) -> dailyMenu.allAdditionalMealsSelected()

  orders: ->
    menus = @_dailyMenus?.map(@_dailyMenuFor.bind(@)) or new Immutable.Map

    menus.filter((dm) -> not dm.isSaved()).map (dm) -> dm.orders()

  _dailyMenuFor: (groupMenus, formattedDate) ->
    new DailyMenuWithOrders(@canteen, moment(formattedDate, dateFormat), groupMenus, @_menu)
